import React, { FunctionComponent } from 'react';
import { Entry, Favorite, Scout } from '../../../types/personShow';

type Props =  {
  favoritesCounts: number;
  entriesCounts: number;
  scoutsCounts: number;
  favorites: Favorite[];
  entries: Entry[];
  scouts: Scout[];
  handleOpenModal: (scoutId: number, scoutTitle: string, scoutCreatedAt: string, scoutMessage: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  favoritesCounts,
  entriesCounts,
  scoutsCounts,
  favorites,
  entries,
  scouts,
  handleOpenModal,
}) => {
  return (
    <div className="person__show__histories">
      <div className="person__show__histories__item">
        <p className="person__show__histories__item--title">求人保存履歴<span>{favoritesCounts}件</span></p>
        <div className="person__show__histories__item__inner">
          {favorites.length > 0 ? (
            favorites.map((favorite) => (
              <a
                href={`/recruitments/${favorite.recruitmentId}`}
                className="person__show__histories__item--list"
                key={favorite.recruitmentId}
              >
                <p className="person__show__histories__item--list--time">{favorite.createdAt}</p>
                <p className="person__show__histories__item--list--content">{favorite.title}</p>
              </a>
            ))
          ) : (
            <p className="person__show__histories__item--list">求人はまだ保存されていません</p>
          )}
        </div>
      </div>
      <div className="person__show__histories__item">
        <p className="person__show__histories__item--title">スカウト履歴<span>{scoutsCounts}件</span></p>
        <div className="person__show__histories__item__inner">
          {scouts.length > 0 ? (
            scouts.map((scout) => (
              <div
                onClick={() => handleOpenModal(scout.id, scout.title, scout.createdAt, scout.message || '')}
                className="person__show__histories__item--list"
                key={scout.id}
              >
                <p className="person__show__histories__item--list--time">
                  {scout.createdAt}
                  {scout.isApplied && (
                    <p className="person__show__histories__item--list--content--applied">応募済み</p>
                  )}
                </p>
                <p className="person__show__histories__item--list--content">{scout.title}</p>
              </div>
            ))
          ) : (
            <p className="person__show__histories__item--list">スカウトをまだしていません</p>
          )}
        </div>
      </div>
      <div className="person__show__histories__item">
        <p className="person__show__histories__item--title">応募履歴<span>{entriesCounts}件</span></p>
        <div className="person__show__histories__item__inner">
          {entries.length > 0 ? (
            entries.map((entry) => (
              <a
                href={entry.recruitmentId ? `/recruitments/${entry.recruitmentId}` : `/events/${entry.eventId}`}
                className="person__show__histories__item--list"
                key={entry.id}
              >
                <p className="person__show__histories__item--list--time">
                  {entry.createdAt}
                  {'category' in entry && entry.category !== '' && (
                    <span className="person__show__histories__item--list--content--applied">{entry.category}</span>
                  )}
                </p>
                <p className="person__show__histories__item--list--content">{entry.title}</p>
              </a>
            ))
          ) : (
            <p className="person__show__histories__item--list">応募はまだありません</p>
          )}
        </div>
      </div>
    </div>
  );
};
